import { render } from "./BackgroundStyle.vue?vue&type=template&id=3c3de46b"
import script from "./BackgroundStyle.vue?vue&type=script&lang=ts"
export * from "./BackgroundStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script